"use strict";

$(document).ready(function () {
    $(".slkCarousel").slick({
        prevArrow: ".slick-prev",
        nextArrow: ".slick-next",
        appendDots: ".slkCarouselNav",
        dots: true,
    });
});

// Variable initialisation
var cType = 1;  // Primary concrete type (ID)
var sType = 0;  // Primary steel type (ID)
var data = {mat: {}, geo: {}, cl: {}, plot: {}}; // Data Struct containing all informations about materials, geometry, calculations, plots
var init = 0; // Flag variable if all plots etc are initialised (1) or not (0)
var f = 50;
var l = 10; // [m]
var h = 1.4; // [m]
var xf = 0.5*l;

var V, M, Av, Bv, x, alpha, vSwitch, alpha1Switch, alpha2Switch;

// Initialise Sliders
var sldPosFX = document.getElementById('sldPosFX');

noUiSlider.create(sldPosFX, {
    start: [xf],
    range: {
        'min': h-0.2,
        'max': l-(h-0.2)
    },
    tooltips: true,
    step: 0.1,
    pips: {
        mode: 'count',
        values: 9,
        density: 2.5
    },
    format: {
        to: function(value){
            return Math.round(value*10)/10;
        },
        from: function(value){
            return value;
        }
    }
});

sldPosFX.noUiSlider.on('slide', updatePosFX);

function updatePosFX(values, handle, unencoded, tap, positions){
    xf = Math.round(values[0]*10)/10;
    
    // Reset alphas...
    /* document.querySelector('input[name="alpha1"]').checked = true;
    document.querySelector('input[name="alphaTwo"]').checked = true; */
    document.getElementById('alpha1').value = 0;
    document.getElementById('alpha2').value = 0;

    document.getElementById('fPosX').innerHTML = xf;

    updCalc();
}

var sldF = document.getElementById('sldForce');

noUiSlider.create(sldF, {
    start: [f],
    range: {
        'min': 0,
        'max': 100
    },
    tooltips: true,
    step: 1,
    pips: {
        mode: 'count',
        values: 11,
        density: 5
    },
    format: {
        to: function(value){
            return Math.round(value);
        },
        from: function(value){
            return value;
        }
    }
});

sldF.noUiSlider.on('slide', updateF);

function updateF(values, handle, unencoded, tap, positions){
    f = Math.round(values[0]);
    document.getElementById('fact').innerHTML = f;
    
    updCalc();
}

updCalc();

function updCalc() {

    //View Mode...
    vSwitch = document.querySelector('input[name="view"]:checked').id;
    alpha1Switch = document.getElementById('alpha1').value;
    alpha2Switch = document.getElementById('alpha2').value;
    
    // Auflagerkräfte berechnen
    Av = (l-xf)*f/l;
    Bv = f-Av;

    // Schnittkräfte berechnen
    V = [[0, 0, xf, xf, l, l], [0, -Av, -Av, -Av+f, Bv, 0]];
    M = [[0, xf, l],[0, Av*xf, 0]];

    // Create structure plot..
    let stPlt;
    stPlt = new Group();

    // Plot Concrete Structure
    let cSt = new Group();
    cSt.addElm(new Rectangle(l, h, l/2, h/2).setFill(col.c_vis.getRgba()));
    cSt.addElm(new Support(0,0,1,0.25));
    cSt.addElm(new Text(-0.1,0,'A'));
    cSt.addElm(new Support(l,0,2,0.25));
    cSt.addElm(new Text(l+0.1,0,'B'));
    stPlt.addElm(cSt);

    // Plot Measurement & Forces...
    let mGrp = new Group();
    mGrp.addElm(new DimLine([0, h+0.1], [xf, h+0.1], 'calcLength [m]', 0.02, 0.5, 0.1));
    mGrp.addElm(new DimLine([l, -0.25], [0, -0.25], 'calcLength [m]', 0.02, 0.2, -0.1));
    stPlt.addElm(mGrp);

    let fGrp = new Group();
    if (f>0) {
        fGrp.addElm(new Force(xf,h,f/100,0,0.5));
    }
    stPlt.addElm(fGrp);

    // Nullpunktdurchgang Querkraft
    let xv0 = xf;

    // Calculate stress fields...
    let alpha = [[],[]];
    // Flag für Spezialfall...
    // = 0 > Kein Spezialfall
    // = 1 > Links
    // = 2 > Rechts...
    let spezialfall = 0;

    // Linke Seite...
    let amax = Math.floor(xv0/(h-0.2)); //Maximale Anzahl Felder mit Winkel 45° (Steilster Winkel)
    let amin = Math.ceil(xv0/((h-0.2)/Math.tan(30/180*Math.PI))); //Minimale Anzahl Felder mit Winkel 30° (Flachster Winkel)
    
    if(amin <= amax){
        for(let i = amin; i <= amax; i++){
            alpha[0].push(Math.atan((h-0.2)/(xv0/i))*180/Math.PI);
        }
    }else{
        // Spezialfall!!!
        // Möglichst flacher Winkel (30°) für flachster Fächerteil
        spezialfall = 1;
        alpha[0].push(30);
    }

    // Rechte Seite
    amax = Math.floor(math.round(l-xv0,1)/(h-0.2));
    /* console.log(amax, (l-xv0)); */
    amin = Math.ceil((l-xv0)/((h-0.2)/Math.tan(30/180*Math.PI)));
    
    if(amin <= amax){
        for(let i = amin; i <= amax; i++){
            alpha[1].push(Math.atan((h-0.2)/((l-xv0)/i))*180/Math.PI);
        }
    }else{
        // Spezialfall!!!
        spezialfall = 2;
        alpha[1].push(30);
    }

    //Refresh Options...
    var html = '';
    if(spezialfall !== 1){
        alpha[0].forEach((item, i) => {
            html += '<option value="'+i+'"';
            if(i == alpha1Switch) html += ' selected'
            html += '> ' + Math.round(item*10)/10+'° </option>';
        });
    }else{
        html = '<option value="0" selected> Spezialfall </option>';
    }
    document.getElementById('alpha1').innerHTML = html;
    
    html = '';
    if(spezialfall !== 2){
        alpha[1].forEach((item, i) => {
            html += '<option value="'+i+'"';
            if(i == alpha2Switch) html += ' selected'
            html += '> ' + Math.round(item*10)/10+'° </option>';

            /* html += '<input id="'+i+'" name="alphaTwo" type="radio" onclick="updCalc()"';
            if(i == alpha2Switch) html += ' checked'
            html += '><label for="'+i+'"> '+Math.round(item*10)/10+'° </label>'; */
        });
    }else{
        html = '<option value="0" selected> Spezialfall </option>';
    }
    document.getElementById('alpha2').innerHTML = html;
    
    // Länge (sL, x, dx); einzelner Fächer...
    let sL = Math.round((h-0.2)/Math.tan(alpha[0][alpha1Switch]/180*Math.PI)*1000)/1000;
    let sR = Math.round((h-0.2)/Math.tan(alpha[1][alpha2Switch]/180*Math.PI)*1000)/1000;

    // Anzahl Parallelfelder
    let nPfL, nPfR;

    if ( Math.abs(Math.round(xv0/sL)-xv0/sL) < 0.01 ) {
        nPfL = Math.round(xv0/sL);
    } else {
        nPfL = Math.floor(xv0/sL);
    }
    
    if ( Math.abs(Math.round((l-xv0)/sR)-(l-xv0)/sR) < 0.01 ) {
        nPfR = Math.round((l-xv0)/sR);
    }else{
        nPfR = Math.floor((l-xv0)/sR);
    }
    
    // Restliche Länge letztes Feld...
    let xSfrL = Math.round((xv0-nPfL*sL)*100)/100;
    let xSfrR = Math.round(((l-xv0)-nPfR*sR)*100)/100;

    if(vSwitch === 'sp' || vSwitch === 'both'){

        // Plot Spannungsfelder...
        let sfL = new Group();

        if(spezialfall === 1){

            //Verzogener Fächer...
            sfL.addElm(new Fan([[0,0.1],[xSfrL,(h-0.1)],[sL,(h-0.1)]]));
            sfL.addElm(new Fan([[xv0,h-0.1],[sL,0.1],[xSfrL,0.1]]));

            // Add sidelines
            sfL.addElm(new Line([xSfrL,xSfrL],[0.1, h-0.1]).setColor(col.sk.getHex()));
            sfL.addElm(new Line([sL,sL],[0.1,h-0.1]).setColor(col.sk.getHex()));

        }else{
            sfL.addElm(new Fan(0,0.1,h-0.2,alpha[0][alpha1Switch]));

            for ( let i=0; i < (nPfL-1); i++ ) {
                sfL.addElm(new ParallelField(i*sL,0.1,h-0.2,alpha[0][alpha1Switch]));
            }

            let tmp = nPfL-1;
            if(tmp < 0) tmp = 0;
            sfL.addElm(new Fan([xv0,xv0,tmp*sL],[h-0.1,0.1,0.1]));

        }

        // Winkel anschreiben
        sfL.addElm(new Circle(0,0.1,0.3,alpha[0][alpha1Switch]).setWidth(0.5));
        sfL.addElm(new Text(0.4, 0.22, 'α<sub>1</sub>'));
        sfL.addElm(new Text(0.7, -0.2, 'α<sub>1</sub> = ' + Math.round(alpha[0][alpha1Switch]*10)/10 + '°'));

        stPlt.addElm(sfL);

        let sfR = new Group();

        if(spezialfall === 2){

            //Verzogener Fächer...
            sfL.addElm(new Fan([[l,0.1],[l-xSfrR,(h-0.1)],[l-sR,(h-0.1)]]));
            sfL.addElm(new Fan([[xv0,h-0.1],[l-sR,0.1],[l-xSfrR,0.1]]));

            // Add sidelines
            sfL.addElm(new Line([l-xSfrR,l-xSfrR],[0.1, h-0.1]).setColor(col.sk.getHex()));
            sfL.addElm(new Line([l-sR,l-sR],[0.1,h-0.1]).setColor(col.sk.getHex()));

        }else{
            sfR.addElm(new Fan(l,0.1,h-0.2,-alpha[1][alpha2Switch]));
            
            for ( let i=0; i < (nPfR-1); i++ ) {
                sfR.addElm(new ParallelField(l-i*sR,0.1,h-0.2,-alpha[1][alpha2Switch]));
            }

            let tmp = (nPfR-1);
            if(tmp < 0) tmp = 0;
            sfL.addElm(new Fan([xv0,xv0,l-tmp*sR],[h-0.1,0.1,0.1]));
        }

        // Winkel anschreiben
        sfR.addElm(new Circle(0,0,0.3,alpha[1][alpha2Switch]).mirrorX().move(l,0.1).setWidth(0.5));
        sfR.addElm(new Text(l-0.4, 0.22, 'α<sub>2</sub>'));
        sfR.addElm(new Text(l-0.7, -0.2, 'α<sub>2</sub> = ' + Math.round(alpha[1][alpha2Switch]*10)/10 + '°'));

        stPlt.addElm(sfR);
    }

    // FWM
    // Berechnung Gurt und Bügelkräfte mit anschliessendem Plot...
    let FWMnodes = [];
    let FWMstruts = [];
    let FWMsupports = [];
    let FWMforces = [];
    let nodeIdUpperStrut = [];
    let nodeIdLowerStrut = [];
    let nodeIdForce;

    // Define nodes...
    let x0 = 0;
    let y0 = 0.1;

    // Untergurt...
    FWMnodes.push({x: x0, y: y0});
    nodeIdLowerStrut.push(FWMnodes.length-1);

    for (let i=0; i<nPfL; i++) {
        FWMnodes.push({x: x0+(sL+xSfrL)/2+i*sL, y: y0});
        nodeIdLowerStrut.push(FWMnodes.length-1);
    }

    for (let i = nPfR-1; i>=0; i--) {
        FWMnodes.push({x: x0+(l-((sR+xSfrR)/2+i*sR)), y: y0});
        nodeIdLowerStrut.push(FWMnodes.length-1);
    }

    FWMnodes.push({x: x0+l, y: y0});
    nodeIdLowerStrut.push(FWMnodes.length-1);

    // Obergurt...
    for (let i=0; i < (nPfL); i++) {
        FWMnodes.push({x: x0+(sL+xSfrL)/2+i*sL, y: y0+h-0.2});
        nodeIdUpperStrut.push(FWMnodes.length-1);
    }

    FWMnodes.push({x: x0+xf, y: y0+h-0.2});
    nodeIdUpperStrut.push(FWMnodes.length-1);
    nodeIdForce = FWMnodes.length-1;

    for (let i = (nPfR-1); i>=0; i--) {
        FWMnodes.push({x: x0+l-((sR+xSfrR)/2+i*sR), y: y0+h-0.2});
        nodeIdUpperStrut.push(FWMnodes.length-1);
    }

    // *** Define struts
    // Gurte
    for (let i=0; i < nodeIdLowerStrut.length-1; i++) {
        FWMstruts.push({node1: i, node2: i+1});
    }

    for (let i=0; i < nodeIdUpperStrut.length-1; i++) {
        FWMstruts.push({node1: nodeIdUpperStrut[i], node2: nodeIdUpperStrut[i+1]});
    }

    // Streben
    for (let i=0; i<nPfL; i++) {
        FWMstruts.push({node1: nodeIdLowerStrut[i+1], node2: nodeIdUpperStrut[i]});
    }

    for (let i=nPfR; i>0; i--) {
        FWMstruts.push({node1: nodeIdLowerStrut[nodeIdLowerStrut.length-1-i], node2: nodeIdUpperStrut[nodeIdUpperStrut.length-i]});
    }

    // Diagonalen ...
    for (let i=0; i<=nPfL; i++) {
        FWMstruts.push({node1: nodeIdLowerStrut[i], node2: nodeIdUpperStrut[i]});
    }

    for (let i=nPfR; i>=0; i--) {
        FWMstruts.push({node1: nodeIdLowerStrut[nodeIdLowerStrut.length-1-i], node2: nodeIdUpperStrut[nodeIdUpperStrut.length-i-1]});
    }

    // *** Define supports
    FWMsupports.push({node: 0, dir: 'x'});
    FWMsupports.push({node: 0, dir: 'y'});
    FWMsupports.push({node: nodeIdLowerStrut[nodeIdLowerStrut.length-1], dir: 'y'});

    // *** Define forces
    FWMforces.push({node: nodeIdForce, fx: 0, fy: -f});

    //console.log(FWMnodes, FWMstruts, FWMsupports, FWMforces);
    //console.log(2*FWMnodes.length-(FWMsupports.length+FWMstruts.length)); //2*k-(sL, x, dx+;l)

    // Solve FWM
    let FWMresult = fwSolver(FWMnodes, FWMstruts, FWMsupports, FWMforces);

    //Write result into strut array...
    FWMresult.forEach((res, resKey) => {
        if (resKey < FWMstruts.length) {
            FWMstruts[resKey]['fn'] = res;
        } else {
            FWMsupports[resKey-FWMstruts.length]['f'] = res;
        }
    });

    //Plot Fachwerk
    if(vSwitch === 'both' || vSwitch === 'fw'){
        let fwm = new Group();
        FWMstruts.forEach((strut) => {
            if ( strut.fn > 0 ) {
                fwm.addElm(new Line(
                    [FWMnodes[strut.node1].x,FWMnodes[strut.node2].x],
                    [FWMnodes[strut.node1].y,FWMnodes[strut.node2].y]
                ).setDash('dot').setWidth(3).setColor(col.fwm_t.getHex()));
            } else if ( strut.fn < 0 ) {
                fwm.addElm(new Line(
                    [FWMnodes[strut.node1].x,FWMnodes[strut.node2].x],
                    [FWMnodes[strut.node1].y,FWMnodes[strut.node2].y]
                ).setDash('dot').setWidth(3).setColor(col.fwm_c.getHex()));
            } else {
                fwm.addElm(new Line(
                    [FWMnodes[strut.node1].x,FWMnodes[strut.node2].x],
                    [FWMnodes[strut.node1].y,FWMnodes[strut.node2].y]
                ).setDash('dot').setWidth(3).setColor(col.base.getHex()));
            }
        });

        stPlt.addElm(fwm);
    }

    // Berechnen der Gurtabschnitte
    let lowerStrut = {
        sectionMid: [],
        sectionWidth: [],
        sectionForce: []
    };

    for (let i=0; i < nodeIdLowerStrut.length-1; i++) {
        lowerStrut.sectionMid.push( (FWMnodes[nodeIdLowerStrut[i]].x+FWMnodes[nodeIdLowerStrut[i+1]].x)/2 );
        lowerStrut.sectionWidth.push( (FWMnodes[nodeIdLowerStrut[i+1]].x-FWMnodes[nodeIdLowerStrut[i]].x) );
        lowerStrut.sectionForce.push( FWMstruts[i].fn );
    }

    let upperStrut = {
        sectionMid: [],
        sectionWidth: [],
        sectionForce: []
    };

    for (let i=0; i < nodeIdUpperStrut.length-1; i++) {
        upperStrut.sectionMid.push( (FWMnodes[nodeIdUpperStrut[i]].x+FWMnodes[nodeIdUpperStrut[i+1]].x)/2 );
        upperStrut.sectionWidth.push( (FWMnodes[nodeIdUpperStrut[i+1]].x-FWMnodes[nodeIdUpperStrut[i]].x) );
        upperStrut.sectionForce.push( FWMstruts[nodeIdLowerStrut.length-1+i].fn );
    }

    let stirrups = {
        sectionMid: [],
        sectionWidth: [],
        sectionForce: []
    };
      
    for (let i=0; i < nPfL; i++) {
        stirrups.sectionMid.push( FWMnodes[nodeIdUpperStrut[i]].x );
        stirrups.sectionWidth.push( sL-xSfrL );
        stirrups.sectionForce.push( FWMstruts[nodeIdLowerStrut.length+nodeIdUpperStrut.length-2+i].fn );
    }

    for (let i = nPfR; i > 0; i--) {
        stirrups.sectionMid.push( FWMnodes[nodeIdUpperStrut[nodeIdUpperStrut.length-i]].x );
        stirrups.sectionWidth.push( sR-xSfrR );
        stirrups.sectionForce.push( FWMstruts[nodeIdLowerStrut.length+nodeIdUpperStrut.length-2+nPfL+nPfR-i].fn );
    }

    // Berechnung der kontinuierlichen Gurtkräfte (Spannungsfeld)
    var conStrut = {
        sup: [],
        supX: [],
        inf: []
    }
    let parallelField, posSup, posInf;

    x = math.range(0, l*(1+1/1000), l/500); //Abstandsvektor
    let dx = x._data[1]-x._data[0];
    var midId = 0;

    x.forEach((item, i) => {
        if(i == 0){
            conStrut.sup.push(0);
            conStrut.inf.push(lowerStrut.sectionForce[0]);
        }else{
            //Superior Strut
            //Fächer...
            if(item < xSfrL){ //Bis am Obergurt Fächer anfängt...
                conStrut.sup.push(0);
            }else if(item <= sL){ //Fächer selbst
                conStrut.sup.push(conStrut.sup[i-1]-(stirrups.sectionForce[0]/(sL-xSfrL)*dx)*item/(h-0.2));
            }else if(item <= nPfL*sL) { //Parallelfelder
                parallelField = Math.floor(item/sL);
                conStrut.sup.push(conStrut.sup[i-1]-(stirrups.sectionForce[parallelField]/sL*dx)/Math.tan(alpha[0][alpha1Switch]*Math.PI/180));
            }else if(item < xf) { //Falls Obergurt nicht geschlossen...
                /* posInf = (item-nPfL*sL)/(l/2-nPfL*sL)*sL; */
                conStrut.sup.push(conStrut.sup[i-1]);
            }else if(math.round(item,1) == xf){
                midId = i[0]-2;
                conStrut.sup.push(upperStrut.sectionForce[nPfL]);
            }else if(l-item <= sR){
                conStrut.sup.push(conStrut.sup[i-1]+(stirrups.sectionForce[stirrups.sectionForce.length-1]/(sR-xSfrR)*dx)*(l-item)/(h-0.2))
            }else if(l-item <= nPfR*sR){
                parallelField = nPfL+nPfR-1-Math.floor(Math.abs(l-item)/sR);
                conStrut.sup.push(conStrut.sup[i-1]+(stirrups.sectionForce[parallelField]/sR*dx)/Math.tan(alpha[1][alpha2Switch]*Math.PI/180));
            }else{
                /* posInf = (l-nPf*xSf-item)/(l/2-nPf*xSf)*xSf; */
                conStrut.sup.push(conStrut.sup[i-1]);
            }

            // Inferior Strut
            if(item < xSfrL){ //Bis am Fächeranfang (Zug aus Auflagerfächer)... > Spezialfall
                conStrut.inf.push(conStrut.inf[i-1]);
            }else if(item <= (nPfL-1)*sL){ //Bis anfangs Fächer Untergurt (Vor Einzellast) > Linear
                parallelField = Math.floor((item-xSfrL)/sL);
                conStrut.inf.push(conStrut.inf[i-1]+(stirrups.sectionForce[parallelField]/(sL-xSfrL)*dx)/Math.tan(alpha[0][alpha1Switch]*Math.PI/180));
            }else if(item <= xf){ //Fächer bis Eizellast > Abhängig von Neigung (Fv/Länge*Increment*x/h)
                conStrut.inf.push(conStrut.inf[i-1]+(stirrups.sectionForce[nPfL-1]/(sL-xSfrL)*dx)*(xf-item)/(h-0.2));
            }else if(l-item < xSfrR){ // Bei Spezialfall bis Auflager
                conStrut.inf.push(conStrut.inf[i-1]);
            }else if(l-item <= (nPfR-1)*sR){ // Ab Fächer Einzellast bis Auflager bzw. Spezialfall
                parallelField = nPfL+nPfR-1-Math.ceil((l-item)/sR);
                conStrut.inf.push(conStrut.inf[i-1]-(stirrups.sectionForce[parallelField]/sR*dx)/Math.tan(alpha[1][alpha2Switch]*Math.PI/180));
            }else{ // Fächer von Einzellast
                conStrut.inf.push(conStrut.inf[i-1]-(stirrups.sectionForce[nPfL]/(sR-xSfrR)*dx)*(item-xf)/(h-0.2));
            }
        }
    });

    conStrut.supX = [...x._data];
    if(midId > 0){
        conStrut.supX.splice(midId, 0, conStrut.supX[midId])
        conStrut.supX.splice(midId, 0, conStrut.supX[midId])
        conStrut.sup.splice(midId,0,conStrut.sup[midId]);
        conStrut.sup.splice(midId,0,conStrut.sup[midId]);
        conStrut.sup[midId+1] = conStrut.sup[midId] - f*(sL/2/(h-0.2));
        if(xf < l/2){
            conStrut.supX.splice(midId, 0, conStrut.supX[midId]);
            conStrut.sup.splice(midId-1,0,conStrut.sup[midId-1]);
        }else if(xf > l/2){
            conStrut.supX.splice(midId+2, 0, conStrut.supX[midId+2]);
            conStrut.sup.splice(midId+3,0,conStrut.sup[midId+3]);
        }
    }

    // *********** Generieren der Plotdaten...
    let plt = stPlt.getPlotData();

       // Create Schnittkraft plot...
       let pltData = {
        Data: [
            {
                x: V[0],
                y: V[1],
                mode: 'lines',
                fill: 'tozeroy',
                fillcolor: col.sk_bg.getRgba(),
                line: {
                    color: col.sk.getRgba(),
                    width: 1
                },
                yaxis: 'y2',
            },
            {
                x: M[0],
                y: M[1],
                mode: 'lines',
                fill: 'tozeroy',
                fillcolor: col.sk_bg.getRgba(),
                line: {
                    color: col.sk.getRgba(),
                    width: 1
                },
                yaxis: 'y3',
            }
        ],
        Layout: {
            hovermode: false,
            height: 700,
            margin: {
                l: 60,
                r: 0,
                b: 50,
                t: 0,
                pad: 0
            },
            xaxis: {
                range: [-0.2, 10.2],
                zeroline: false,
                title: 'x [m]',
            },
            yaxis: {
                range: [-0.6,2.5],
                scaleanchor: 'x',
                domain: [0.5, 1.0],
                showgrid: false,
                zeroline: false,
                showline: false,
                showticklabels: false,
            },
            yaxis2: {
                title: 'V [kN]',
                domain: [0.25, 0.5],
                range: [-150, 150],
            },
            yaxis3: {
                title: 'M [kNm]',
                domain: [0.0, 0.25],
                range: [275, -25],
            },
            grid: {
                rows: 3,
                columns: 1,
            },
            showlegend: false
        },
    };
    plt.data.map((item) => {
        item.yaxis = 'y';
    });

    pltData.Data = pltData.Data.concat(plt.data);
    Plotly.react("plotSk", pltData.Data, pltData.Layout, pltConfig); 

    // Fachwerkkräfte plotten...

    pltData = {
        Data: [],
        Layout: {
            hovermode: false,
            height: 700,
            margin: {
                l: 60,
                r: 0,
                b: 50,
                t: 0,
                pad: 0
            },
            xaxis: {
                range: [-0.2, 10.2],
                zeroline: false,
                showgrid: true,
                title: 'x [m]',
            },
            yaxis: {
                range: [-0.6,2.5],
                scaleanchor: 'x',
                domain: [0.5, 1.0],
                showgrid: false,
                zeroline: false,
                showline: false,
                showticklabels: false,
            },
            yaxis2: {
                title: 'Fsup [kN]',
                range: [0, -230],
                domain: [0.25, 0.5],
            },
            yaxis3: {
                title: 'Finf [kN]',
                range: [0,230],
                domain: [0.0, 0.25],
            },
            grid: {
                rows: 3,
                columns: 1,
            },
            showlegend: false
        },
    };

    if(vSwitch === 'sp' || vSwitch === 'both'){
        // SP lines...
        pltData.Data.push(
            {
                mode: 'lines',
                x: conStrut.supX, //x._data,
                y: conStrut.sup,
                line: {
                    color: col.forces.getRgba(),
                    width: 2
                },
                yaxis: 'y2'
            }
        );
        pltData.Data.push(
            {
                mode: 'lines',
                x: x._data,
                y: conStrut.inf,
                line: {
                    color: col.forces.getRgba(),
                    width: 2
                },
                yaxis: 'y3'
            }
        );
    }

    if(vSwitch === 'fw' || vSwitch === 'both'){
        pltData.Data.push(
            {
                type: 'bar',
                x: upperStrut.sectionMid,
                y: upperStrut.sectionForce,
                width: upperStrut.sectionWidth,
                marker: {
                    color: col.fwm_c.getRgba(),
                    opacity: 0.6,
                    line: {
                        color: col.base.getRgba(),
                        width: 1
                    }
                },
                yaxis: 'y2'
            }
        );
        pltData.Data.push(
            {
                type: 'bar',
                x: lowerStrut.sectionMid,
                y: lowerStrut.sectionForce,
                width: lowerStrut.sectionWidth,
                marker: {
                    color: col.fwm_t.getRgba(),
                    opacity: 0.6,
                    line: {
                        color: col.base.getRgba(),
                        width: 1
                    }
                },
                yaxis: 'y3'
            }
        );
    }
    
    pltData.Data = pltData.Data.concat(plt.data);
    Plotly.react("plotFr", pltData.Data, pltData.Layout, pltConfig);

    // Bügelkräfte...
    pltData = {
        Data: [
            {
                type: 'bar',
                x: stirrups.sectionMid,
                y: stirrups.sectionForce,
                width: stirrups.sectionWidth,
                marker: {
                    color: col.fwm_t.getRgba(),
                    opacity: 0.6,
                    line: {
                        color: col.base.getRgba(),
                        width: 1
                    }
                },
                yaxis: 'y2'
            }
        ],
        Layout: {
            hovermode: false,
            height: 700,
            margin: {
                l: 60,
                r: 0,
                b: 60,
                t: 0,
                pad: 0
            },
            xaxis: {
                range: [-0.2, 10.2],
                zeroline: false,
                title: 'x [m]',
                showgrid: true,
            },
            yaxis: {
                range: [-0.6,2.5],
                scaleanchor: 'x',
                domain: [0.5, 1.0],
                showgrid: false,
                zeroline: false,
                showline: false,
                showticklabels: false,
            },
            yaxis2: {
                title: 'Fw [kN]',
                range: [0,100],
                domain: [0.25, 0.5],
            },
            /* yaxis3: {
                title: 'Finf [kN]',
                range: [0,1100],
                domain: [0.0, 0.2],
            }, */
            grid: {
                rows: 2,
                columns: 1,
            },
            showlegend: false
        },
    };
    pltData.Data = pltData.Data.concat(plt.data);
    Plotly.react("plotFw", pltData.Data, pltData.Layout,  pltConfig);
    
    /* Live Values */
    document.getElementById('mom').innerHTML = math.round(Av*xf,0);
    document.getElementById('fa').innerHTML = math.round(Av,0);
    document.getElementById('fb').innerHTML = math.round(Bv,0);
    document.getElementById('fsupmin').innerHTML = math.round(math.min(upperStrut.sectionForce),0);
    document.getElementById('finfmax').innerHTML = math.round(math.max(lowerStrut.sectionForce),0);
    document.getElementById('fwmax').innerHTML = math.round(math.max(stirrups.sectionForce),0);
    document.getElementById('finfa').innerHTML = math.round(lowerStrut.sectionForce[0],0);
    document.getElementById('finfb').innerHTML = math.round(lowerStrut.sectionForce[lowerStrut.sectionForce.length-1],0);
}

/**
 * Function to multiply data by 10^pow. It doesn't matter if data is an integer, double, array or vector from the math library
 * @param data Integer, Double, Array or Vector which elements should be converted
 * @param pow Power (10^pow)
 * @returns {*} Converted input data
 */
function convData(data, pow) {
    if (typeof data === 'object') {
        if (Array.isArray(data)) {
            return data.map(function (value) {
                return value * Math.pow(10, pow);
            });
        } else {
            return math.map(data, function (value) {
                return value * Math.pow(10, pow);
            });
        }
    } else {
        return data * Math.pow(10, pow);
    }

}